import React from 'react';
import { get } from 'lodash';
import { Card, CardHeader } from 'common/Card';
import { usePopulate } from 'api/APIHooks';
import PropTypes from 'prop-types';
import { epochToDate } from 'common/utils/utils';
import { FullWidthDetailList } from '../Layout';
import { BaseLineItem } from '../LineItems';
import CaseStatus from '../../../components/CaseStatus';

const ReferralDetailsCard = ({ referrals, serviceAuthorization }) => {
  const refsLoaded = referrals.length > 0;
  const kase = get(serviceAuthorization, 'case', {});
  const isCaseLoaded = !!kase?.description;
  const authorizationAcceptedOrDeferred =
    ['approved', 'deferred'].includes(serviceAuthorization.state) && kase.state !== 'pending_authorization';
  const referralAccepted = kase.state === 'managed';
  const caseOpenedDate = epochToDate(kase.opened_date);
  const caseClosedDate = epochToDate(kase.closed_date);
  usePopulate('provider', 'provider', kase, { queryConfig: { placeholderData: undefined } });
  const receivingProviderName = kase.provider.name;

  return (
    <Card className="bg-white" data-testid="referral-details-card">
      <CardHeader
        className="pt-2 pl-2 space-y-2"
        title="Referral"
      />
      <FullWidthDetailList className="p-6">
        {authorizationAcceptedOrDeferred && (
          <BaseLineItem
            field="Case Status"
            isLoaded={refsLoaded}
            dataTestElement="referral-status"
          >
            <CaseStatus
              state={kase.state}
              openedDate={caseOpenedDate}
              closedDate={caseClosedDate}
              showStatusDot={false}
            />
          </BaseLineItem>
        )}
        {referralAccepted && (
          <BaseLineItem
            field="Accepted by"
            isLoaded={refsLoaded}
            dataTestElement="referral-accepted-by"
          >
            {receivingProviderName}
          </BaseLineItem>
        )}
        <BaseLineItem
          field="Recipient Network"
          isLoaded={refsLoaded}
          dataTestElement="referral-recipient-network"
        >
          {get(referrals, '[0].receiving_network.name')}
        </BaseLineItem>
        <BaseLineItem
          field="Sent to"
          isLoaded={refsLoaded}
          dataTestElement="referral-recipient-organization"
        >
          {referrals.map((r) => (r.receiving_provider.name)).join(', ')}
        </BaseLineItem>
        <BaseLineItem
          field="Description"
          isLoaded={isCaseLoaded}
          dataTestElement="referral-description"
        >
          {get(serviceAuthorization, 'case.description')}
        </BaseLineItem>
      </FullWidthDetailList>
    </Card>
  );
};

ReferralDetailsCard.propTypes = {
  referrals: PropTypes.array.isRequired,
  serviceAuthorization: PropTypes.object.isRequired,
};

export default ReferralDetailsCard;
